import parseImportTimestamp from './parseImportTimestamp';

/**
 * Resolves the Timestamp for one imported response. The app groups responses
 * into a single "submission" by their millisecond Timestamp, so every
 * respondent row MUST end up on a distinct millisecond — also when the file
 * has no (parseable) date. The old fallback wrote the same server-timestamp
 * sentinel for every row, collapsing all respondents into one form (inbox #82).
 * AI-CONTEXT: See docs/pitfalls.md#database-responses-grouped-by-millisecond-timestamp
 *
 * @param {*} timestampRaw - Raw cell value from the file's Timestamp column ('' when absent).
 * @param {number|undefined} sessionIndex - Per-respondent row index within this import.
 * @param {Date} runDate - Wall-clock moment of this import run (fallback base).
 * @returns {Date} The date to write as the response's Timestamp.
 */
const resolveResponseTimestamp = (timestampRaw, sessionIndex, runDate) => {
    const base = parseImportTimestamp(timestampRaw) || runDate;
    return new Date(base.getTime() + (sessionIndex || 0));
};

export default resolveResponseTimestamp;
